import styles from "./Footer.module.scss";

export const Footer = () => {
  return <footer className={styles.root}>Friday Report Copyright ©</footer>;
};
